module.exports = __webpack_public_path__ + "static/media/ic-search-light.9dfb2b8e.svg";